import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit {

  safeSrc: any;

  constructor(
    private dialogRef: MatDialogRef<any>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    var link = this.data.videoURL
    if(link.substr(0,7).toLowerCase() == "http://" || link.substr(0,8).toLowerCase() == "https://"){
        link = link;
      }else{
        link = "http://" + link;
      }
    this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(link)
  }

  cancel() {
    this.dialogRef.close();
  }

}
